import axios from "axios";
import { useEffect, useState ,useRef} from "react";
import { Send, RotateCw } from "lucide-react";
import "../index.css";




const messagesDb ={
  0 : {
      role: "AI",
      content: "Hi, I'm Youssef. Welcome to my portfolio! Feel free to ask me about my projects, skills, or anything else!",
      read:false
    },
  };

const Message = ({ id, setSubmitButton, setThinkingDots, chatWindowRef}) => {
  const [messagePortion, setMessagePortion] = useState("");


  useEffect(() => {
    const dynamicWriting=[];
    
    if (messagesDb[id].role === "AI" && !messagesDb[id].read){
      setThinkingDots(false);
      [...messagesDb[id].content].forEach((e, index) => {
        
       dynamicWriting[index] = setTimeout(() => {
          setMessagePortion(messagesDb[id].content.substr(0, index + 1));
          
            chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight
          if(index === messagesDb[id].content.length -1){
            setSubmitButton(false);
            messagesDb[id].read = true
          }
        }, 80 * index);
      });
    }else{
      setMessagePortion(messagesDb[id].content);
      setSubmitButton(false);
    }
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight


    
    return () =>{
      dynamicWriting.forEach((e) =>clearTimeout(e))
    }

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  return (
      <div>
        <div class={`chat  ${messagesDb[id].role === "AI" ? "chat-start" : "chat-end"} px-1`}>
          <div className=" chat-image">
            <img
              className={`h-7 rounded-full ${messagesDb[id].role === "user" && "hidden"}`}
              src="./assets/yichiba.jpg"
              alt=""
            />
            <img
              className={`h-7 rounded-full ${messagesDb[id].role === "AI" && "hidden"}`}
              src="./assets/users-icon.jpg"
              alt=""
            />
          </div>
          <div class="chat-bubble bg-gray-400 text-black ">{messagePortion}</div>
        </div>
      </div>
  );
};

const tabId = sessionStorage.tabId ? sessionStorage.tabId : Math.random();

export const ChatBot = ({ setChatBot,chatBot, darkMode }) => {
  const chatWindowRef=useRef(null)
  const[thinkinDots,setThinkingDots]=useState(false)
  const [input, setInput] = useState("");
  const [submitButton, setSubmitButton] = useState(true);
  const [messages, setMessages] = useState(Object.keys(messagesDb));
  
  


  const addMessage = (Content , Role) => {


    const newMessage = {
      role: Role,
      content: Content,
      read: false,
    };


    const newId = Object.keys(messagesDb).length; 
    messagesDb[newId] = newMessage;
  };

  const submitPrompt = async () => {
    

    if (submitButton || input === "") return;
    setThinkingDots(true);
    setSubmitButton(true);
    addMessage(input, "user")
    setMessages(Object.keys(messagesDb));
    setInput("");

    
    try {
      const response = await axios.post("https://portfolio-bot-eta.vercel.app/ask",
        {
          content: input,
          tabId,
        }
      );
      addMessage(response.data,"AI")
    } catch (e) {
      addMessage("Error" ,"AI")
    }

    setMessages(Object.keys(messagesDb));
  };

  const handleInput = (event) => {
    setInput(event.target.value);
  };



  const handleClearChat = ()=>{
    if(submitButton) return
    Object.keys(messagesDb).forEach((key)=> delete(messagesDb[key]));
    setMessages(Object.keys(messagesDb))
    setThinkingDots(false);
  }




  return (
    <div
      className={`flex flex-col h-full rounded-xl border-[1px]
        ${
          darkMode
            ? "bg-[#181a1b] text-white border-black"
            : "bg-white  text-black"
        }  w-full md:w-96`}
    >
      <div
        className={`flex h-12 border-b-[1px] rounded-xl px-2
        ${
          darkMode
            ? "bg-[#181a1b] text-white  border-black"
            : "bg-white   border-gray-300 text-black"
        }`}
      >
        <div className="flex gap-1 items-center w-3/5 ">
          <img
            className={` rounded-full h-2/3 border-[1px] ${
              darkMode ? "border-black " : "border-white  "
            }`}
            src="./assets/yichiba.jpg"
            alt=""
          />
          <text className=" text-sm">Yichiba Bot</text>
        </div>
        <div className=" flex ml-auto p-1  gap-3 items-center">
          <button
            onClick={() => handleClearChat()}
            className={`  hover:bg-gray-500  border-[1px]  hover:text-white rounded-full p-1
            ${darkMode ? "border-black " : "  text-black"}`}
          >
            <RotateCw width={16} height={16} />
          </button>
          <div
            className={` flex hover:bg-gray-500 border-[1px]  px-[6.5px] rounded-full ${
              darkMode
                ? "bg-[#181a1b] text-white border-black  "
                : "bg-white   text-black"
            }`}
          >
            <button
              onClick={() => {
                setSubmitButton(false);
                setThinkingDots(false);
                setChatBot(false);
              }}
              className="  hover:text-white"
            >
              X
            </button>
          </div>
        </div>
      </div>
      <div
        ref={chatWindowRef}
        className=" flex flex-col  gap-3  flex-1 overflow-y-auto scroll-auto "
      >
        { messages.map((id) => {
          return (
            <Message
            key={id}
              id={id}
              setSubmitButton={setSubmitButton}
              setThinkingDots={setThinkingDots}
              chatWindowRef={chatWindowRef}              
            />
          );
        })}
        {thinkinDots && (
          <div class={` chat  chat-start px-1`}>
            <div className=" chat-image">
              <img
                className={`h-7 rounded-full `}
                src="./assets/yichiba.jpg"
                alt=""
              />
            </div>
            <div class="chat-bubble bg-gray-400 text-black w-16">
              <div class="typing">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        className={`  flex items-center min-h-16 rounded-lg px-2 border-[1px] ${
          darkMode
            ? "bg-[#181a1b] text-white border-black  "
            : "bg-white   text-black"
        }`}
      >
        <div className=" flex w-full min-h-9 items-center gap-1 rounded-xl">
          <input
            type="text"
            placeholder="Enter message"
            value={input}
            onKeyDown={(e) => {
              if (e.key === "Enter") submitPrompt(e);
            }}
            onChange={(e) => handleInput(e)}
            className={` flex flex-1 rounded-xl min-h-9 px-2  ${
              darkMode
                ? "bg-[#181a1b] text-white border-black  "
                : "bg-white   text-black"
            }`}
          />
          <div className="flex justify-center  items-center  w-9">
            <button
              onClick={() => submitPrompt()}
              className=" flex items-center  justify-center  rounded-lg p-1 "
            >
              <Send
                className={` hover:fill-current transition-all duration-200
                  ${darkMode ? "text-white" : "text-black"}`}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
